import { FEATURE, FEATURE_FLAG, INFLUENCERS } from '../constants/features';
import { EMPTY } from '../constants';

import { reduce } from './iterable/reduce';

function isWhitelisted({ userId, users }) {
  switch (users) {
    case 'all': {
      return true;
    }

    case 'none': {
      return false;
    }

    default: {
      return users.has(userId);
    }
  }
}

function isFeatureEnabled({ feature, userId }) {
  switch (feature) {
    case FEATURE.AFFILIATES: {
      return (
        FEATURE_FLAG.AFFILIATES_ENABLED &&
        isWhitelisted({ userId, users: FEATURE_FLAG.AFFILIATES_USERS })
      );
    }

    case FEATURE.AI_CREDITS: {
      return (
        FEATURE_FLAG.AI_CREDITS_ENABLED &&
        isWhitelisted({ userId, users: FEATURE_FLAG.AI_CREDITS_USERS })
      );
    }

    case FEATURE.AI_PROFILES: {
      return (
        FEATURE_FLAG.AI_PROFILES_ENABLED &&
        isWhitelisted({ userId, users: FEATURE_FLAG.AI_PROFILES_USERS })
      );
    }

    case FEATURE.BULK_EDIT_ALT_TEXT: {
      return (
        FEATURE_FLAG.BULK_EDIT_ALT_TEXT_ENABLED &&
        isWhitelisted({ userId, users: FEATURE_FLAG.BULK_EDIT_ALT_TEXT_USERS })
      );
    }

    case FEATURE.ETSY_PERSONALIZATION_QUESTIONS: {
      return (
        FEATURE_FLAG.ETSY_PERSONALIZATION_QUESTIONS_ENABLED &&
        isWhitelisted({ userId, users: FEATURE_FLAG.ETSY_PERSONALIZATION_QUESTIONS_USERS })
      );
    }

    case FEATURE.IMAGE_GROUPING: {
      return (
        FEATURE_FLAG.IMAGE_GROUPING_ENABLED &&
        isWhitelisted({ userId, users: FEATURE_FLAG.IMAGE_GROUPING_USERS })
      );
    }

    case FEATURE.LISTING_PREVIEW_LINK: {
      return (
        FEATURE_FLAG.LISTING_PREVIEW_LINK_ENABLED &&
        isWhitelisted({ userId, users: FEATURE_FLAG.LISTING_PREVIEW_LINK_USERS })
      );
    }

    case FEATURE.PHOTO_EDITOR_VIDEO: {
      return (
        FEATURE_FLAG.PHOTO_EDITOR_VIDEO_ENABLED &&
        isWhitelisted({ userId, users: FEATURE_FLAG.PHOTO_EDITOR_VIDEO_USERS })
      );
    }

    case FEATURE.PHOTO_SCORING: {
      return (
        FEATURE_FLAG.PHOTO_SCORING_ENABLED &&
        isWhitelisted({ userId, users: FEATURE_FLAG.PHOTO_SCORING_USERS })
      );
    }

    case FEATURE.VIDEO_GROUPING: {
      return (
        FEATURE_FLAG.VIDEO_GROUPING_ENABLED &&
        isWhitelisted({ userId, users: FEATURE_FLAG.VIDEO_GROUPING_USERS })
      );
    }

    case FEATURE.VIDEO_STUDIO: {
      return (
        FEATURE_FLAG.VIDEO_STUDIO_ENABLED &&
        isWhitelisted({ userId, users: FEATURE_FLAG.VIDEO_STUDIO_USERS })
      );
    }

    case FEATURE.WEBINAR_BANNER: {
      return (
        FEATURE_FLAG.WEBINAR_BANNER_ENABLED &&
        isWhitelisted({ userId, users: FEATURE_FLAG.WEBINAR_BANNER_USERS })
      );
    }

    default: {
      return false;
    }
  }
}

export function getUserFeatures(userId) {
  function reduceFeatures(result, feature) {
    return result.set(feature, isFeatureEnabled({ feature, userId }));
  }

  return reduce(FEATURE, EMPTY.MAP, reduceFeatures);
}

export function isInfluencer(userId) {
  return isWhitelisted({ userId, users: INFLUENCERS });
}
